import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'adahi-accordion',
  templateUrl: './accordion.component.html',
 
  
})
export class AdahiAccordionComponent implements  OnInit{
  ngOnInit() {
  }

}